export const StreamStatus = {
  PENDING: 'pending',
  ACTIVE: 'active',
  IDLE: 'idle',
  ENDED: 'ended',
  ERROR: 'error',
} as const;
export type StreamStatus = (typeof StreamStatus)[keyof typeof StreamStatus];

export const IngestProtocol = {
  RTMPS: 'RTMPS',
  SRT: 'SRT',
} as const;
export type IngestProtocol = (typeof IngestProtocol)[keyof typeof IngestProtocol];
